import {
  EuiButtonEmpty,
  EuiButtonIcon,
  EuiCodeBlock,
  EuiFlexGroup,
  EuiFlexItem,
  EuiPanel,
  EuiSpacer,
  EuiText,
} from "@inscopix/ideas-eui";
import { useToolEditorContext } from "components/ToolEditor/Provider/ToolEditorProvider";
import { useLocalStorage } from "hooks/useLocalStorage";

export const ToolEditorFormCodeConfigInstructions = () => {
  const toolKey = useToolEditorContext((s) => s.tool.key);

  const [isConfigCollapsed, setIsConfigCollapsed] = useLocalStorage(
    "isx.ToolEditorConfigCollapsed",
    false,
  );

  const handleClickConfigExpandCollapse = () => {
    setIsConfigCollapsed((prev) => !prev);
  };

  return (
    <EuiPanel>
      <EuiFlexGroup gutterSize="xs" alignItems="center">
        <EuiFlexItem grow={false}>
          <EuiButtonIcon
            size="s"
            title={
              isConfigCollapsed
                ? "Show configuration instructions"
                : "Hide configuration instructions"
            }
            iconType={isConfigCollapsed ? "arrowRight" : "arrowDown"}
            onClick={handleClickConfigExpandCollapse}
          />
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiButtonEmpty
            color="text"
            onClick={handleClickConfigExpandCollapse}
          >
            <EuiText size="s">
              <h3>
                Start by Configuring and Testing your Tool Locally with IDEAS
                CLI
              </h3>
            </EuiText>
          </EuiButtonEmpty>
        </EuiFlexItem>
      </EuiFlexGroup>
      {!isConfigCollapsed && (
        <>
          <EuiSpacer size="s" />
          <EuiText size="s">
            <p>
              Configure your tool locally for testing in your code directory
            </p>
          </EuiText>
          <EuiCodeBlock language="shell" isCopyable paddingSize="m">
            {`ideas tools configure ${toolKey}`}
          </EuiCodeBlock>
          <EuiSpacer size="s" />
          <EuiText size="s">
            <p>Run your tool locally and validate execution and outputs</p>
          </EuiText>
          <EuiCodeBlock language="shell" isCopyable paddingSize="m">
            {`ideas tools run ${toolKey}`}
          </EuiCodeBlock>
          <EuiSpacer size="s" />
          <EuiText size="s">
            <p>Bundle your code and tool config</p>
          </EuiText>
          <EuiCodeBlock language="shell" isCopyable paddingSize="m">
            {`ideas tools bundle`}
          </EuiCodeBlock>
        </>
      )}
    </EuiPanel>
  );
};
